// "Report data issue" — secondary header action (BUILD-ORDER-data-feedback).
//
// Self-contained: renders the outline button (ShareButton styling verbatim)
// plus its modal, so both embed points (player profile HeaderActions, club
// profile header) stay one-line changes.
// Mobile declaration (UI rule 1): the label stays visible at every width —
// the embedding action rows declare flex-wrap, so at 375px this button WRAPS
// onto its own line instead of shrinking, truncating or disappearing; the
// modal itself is the standard bottom sheet (items-end sm:items-center).
import { useState } from "react";

import ReportDataIssueModal from "./ReportDataIssueModal";

const FlagIcon = () => (
  <svg
    width="14"
    height="16"
    viewBox="0 0 18 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M1 14C1 14 2 13 5 13C8 13 10 15 13 15C16 15 17 14 17 14V2C17 2 16 3 13 3C10 3 8 1 5 1C2 1 1 2 1 2V14ZM1 14V21"
      stroke="#2C2C2C"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ReportDataIssueButton = ({ entityType, wyscoutId, tsCoachId, entityName }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  // No id -> nothing to report against (same guard style as
  // AddToRadarButton's `if (!hasId) return null;`). Coaches carry a
  // TheSports string id instead of the numeric wyscout id.
  if (!wyscoutId && !tsCoachId) return null;

  return (
    <>
      <button
        type="button"
        onClick={() => setIsModalOpen(true)}
        className="border border-[#E6E6E6] rounded-lg px-4 py-2 min-h-[44px] sm:min-h-0 flex items-center gap-2 hover:bg-gray-50 transition-colors whitespace-nowrap"
        aria-label="Report data issue"
      >
        <FlagIcon />
        <span className="text-[#1E1E1E]">Report data issue</span>
      </button>
      <ReportDataIssueModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        entityType={entityType}
        wyscoutId={wyscoutId}
        tsCoachId={tsCoachId}
        entityName={entityName}
      />
    </>
  );
};

export default ReportDataIssueButton;
